import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { VMQuotes, useGetByIdQuotes } from "@4pace-cpq/core/api";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function AdditionalQuoteTextBlock({
  item,
}: {
  item: VMQuotes;
}): JSX.Element {
  const { t } = useTranslation();

  const { data: quoteData } = useGetByIdQuotes(
    {
      path: { id: item.id },
      query: { Includes: "PropertySet.Properties.Translations.Language" },
    },
    undefined,
    { enabled: !!item.id },
  );

  const geolocationId = quoteData?.propertySet?.properties?.find(
    (property) => property.identifier === "QuoteCreationGeolocation",
  );
  const isGeolocationDE = geolocationId?.value === "DE";

  return (
    <>
      {isGeolocationDE && (
        <Box
          sx={{
            marginBottom: "1rem",
          }}
        >
          <Typography sx={{ whiteSpace: "pre-line" }}>
            {t("regiolux:additionalQuoteFields.textBlock")}
          </Typography>
        </Box>
      )}
    </>
  );
}
